import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FormButton from "../../../Components/Buttons/FormButton";
import Table, { Column } from "../../../Components/Tables/Table";
import { HistoryLayoutDataReplenishmentDetails, replenishmentdetailslist } from "../../../Data/testData";
import PageHeader from "../../../Layout/PageHeader";
import historyIcon from "../../../assets/images/history-icon.svg";
import HistoryLayout from "../../../Layout/HistoryLaout";
import DynamicDetailGrid from "../../../Components/Grid/DynamicDetailGrid";

export default function ReplenishmentDetails() {
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();
    const pageName = `Replenishment (${id})`;
    const [collapseStates, setCollapseStates] = useState<boolean[]>([false]);
    const toggleCollapse = (index: number) => {
        const updatedCollapseStates = [...collapseStates];
        updatedCollapseStates[index] = !updatedCollapseStates[index];
        setCollapseStates(updatedCollapseStates);
    };

    const [isShowCanvas, setShowCanvas] = useState(false);
    const handelCanvas = () => {
       setShowCanvas(!isShowCanvas);
    };
    const historyData = (
        <>
            <div
                className="d-flex justify-content-between w-100 align-items-center px-4"
                onClick={handelCanvas}
            >
                <div>
                    <h6 className="cursor-pointer m-0 d-flex align-items-center">
                        <img src={historyIcon} className="me-2" />
                        History
                    </h6>
                </div>
            </div>
        </>
    );
    const columns: Column[] = [
        {
            name: "Line#",
            selector: (row: { line: string }) => row.line,
        },
        {
            name: "Item Code",
            selector: (row: { itemCode: string }) => row.itemCode,
        },
        {
            name: "Item Description",
            selector: (row: { itemDesc: string }) => (
                <span   title={row.itemDesc.length > 15 ? row.itemDesc : ""}>
                {row.itemDesc.length > 15
                  ? `${row.itemDesc.slice(0, 15)}...`
                  : row.itemDesc}
              </span>
            ),
        },
        {
            name: "Qty On Hand",
            selector: (row: { qtyOnHand: string }) => row.qtyOnHand,
        },
        {
            name: "Qty Available Now",
            selector: (row: { qtyAvailableNow: string }) => row.qtyAvailableNow,
        },
        {
            name: "Min Stock Level",
            selector: (row: { minStockLevel: string }) => row.minStockLevel,
        },
        {
            name: "Max Stock Level",
            selector: (row: { maxStockLevel: string }) => row.maxStockLevel,
        },
        {
            name: "From",
            selector: (row: { from: string }) => row.from,
        },
        {
            name: "To",
            selector: (row: { to: number }) => row.to,
        },
        {
            name: "Transfer Qty",
            selector: (row: { transferQty: number }) => row.transferQty,
        },
    ];

    const ReplenishmentData=[
        {label: "Transfer Date", value: "03/15/2023"},
        {label: "From Inventory Status", value: "Finished Goods"},
        {label: "To Inventory Status", value: "Found Inventory"},
        {label: "Assigned To", value: "Drake"},
        {label: "Created On", value: "03/15/2023"},
        {label: "No. of Lines", value: "6"},
        { label: 'Status', value: (
            <>
                <div className="text-dark w-auto px-4 badge asn-overview-status w-70 asn-overview-status-border-blue">
                    New
                </div>
            </>
        )
        }
    ]
    return (
        <>
            <PageHeader
                addUrl="/inbound/asn/overview/add"
                listUrl="/inventory/replenishment"
                viewType={true}
                isHistoryEnabled={true}
                historyData={[historyData]}
            />
            <h5 className="text-start mt-1 mb-3">{pageName}</h5>
            <div className="bg-white rounded py-1 px-2 d-flex flex column">
                <DynamicDetailGrid customClassName="col-10" isExpandable={false} columns={3} data={ReplenishmentData} />
            </div>
            <div className="mt-2 bg-white rounded py-1 px-4">
                <Table
                    columns={columns}
                    data={replenishmentdetailslist}
                    CheckboxStatus={false}
                    isStripped={true}
                    customClassName="transferDetailsTable"
                />
            </div>
            <div className="mt-auto bg-white rounded py-3">
                <div className="d-flex flex-row-reverse">
                    <FormButton
                        tabIndex={11}
                        className="sph-btn me-4"
                        handleClick={() => {
                            navigate(`/inventory/replenishment/replenishment-edit/${id}`);
                        }}
                    >
                        Edit
                    </FormButton>
                </div>
            </div>

            <HistoryLayout isShowCanvas={isShowCanvas} handelCanvas={handelCanvas} data={HistoryLayoutDataReplenishmentDetails}/>

        </>
    );
}
